import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Col,
} from 'reactstrap';
import { getStateCodes } from '../actions/ProposalsEditor';
import Location from '../components/Location/index'

const E911AddressModal = ({
  isOpen,
  onCancel,
  data,
  onUpdate,
  selectedNumberTitle,
  onRemoveAddress,
  port,
}) => {
  const [state, setState] = useState(data);
  const [locationState, setLocationState] = useState({});
  const dispatch = useDispatch();

  const handleChange = e => {
    setState({ ...state, [e.currentTarget.name]: e.currentTarget.value });
  };

  useEffect(() => {
    dispatch(getStateCodes(localStorage.getItem('jwtToken')));
  }, []);

  const removeButton = (
    <Button color="primary" onClick={onRemoveAddress}>
      Remove Address
    </Button>
  );

  const getLocationInfo = ev => {
    if (ev) {
      setLocationState({
        address1: ev?.address,
        address2: ev?.address2,
        city: ev?.city,
        state: ev?.state,
        zip: ev?.zip,
        country: ev?.country,
      });
    }
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader close={port?.e911Enabled && removeButton}>{selectedNumberTitle}</ModalHeader>
      <ModalBody>
        <FormGroup row>
          <Label for="callername" sm={4}>
            Caller Name:
          </Label>
          <Col sm={12}>
            <Input
              required
              type="text"
              name="callername"
              placeholder="Caller Name..."
              defaultValue={data?.callername}
              onChange={handleChange}
            />
          </Col>
        </FormGroup>
        <Location
            disabled={false}
            boxDbLocation={state.length ? state : data}
            getLocationInfo={getLocationInfo}
            latLang={false}
            address2={true}
        />
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => {
            var obj = state;
            obj['dn'] = selectedNumberTitle;
            onUpdate({...obj, ...locationState});
          }}
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default E911AddressModal;
